'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import { connect } from 'react-redux';
import { BLOG_TYPE_NOUN_KEY } from '../i18nConstants';
import { getIsSaveInProgress, getWasLastSaveSuccessful, getIsSavePermanentlyDisabled } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasBeenSavedOnceThisSession, getLastSaveDate, getWasLastSaveAnAutoSave } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsSavingEnabled, getHasPermissionsToSave } from '../redux/selectors/saveSelectors';
import BaymaxSaveButton from 'ContentEditorUI/components/header/BaymaxSaveButton';
import { getHasSaveError } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  allowedSave: getHasPermissionsToSave(state),
  contentTypeNoun: I18n.text(BLOG_TYPE_NOUN_KEY),
  isDisabled: !getIsSavingEnabled(state),
  lastSavedDate: getLastSaveDate(state),
  wasLastSaveAnAutoSave: getWasLastSaveAnAutoSave(state),
  hasBeenSavedOnceThisSession: getHasBeenSavedOnceThisSession(state),
  isSaving: getIsSaveInProgress(state),
  lastSaveSuccessful: getWasLastSaveSuccessful(state),
  permanentlyDisabled: getIsSavePermanentlyDisabled(state),
  hasSaveError: getHasSaveError(state),
  isUngatedForPatagonia: getIsUngatedForPatagonia(state)
});
const BlogSaveButtonContainer = ({
  allowedSave,
  contentTypeNoun,
  isDisabled,
  onSaveClick,
  permanentlyDisabled,
  isUngatedForPatagonia
}) => {
  return /*#__PURE__*/_jsx(BaymaxSaveButton, {
    allowedSave: allowedSave,
    contentTypeNoun: contentTypeNoun,
    isDisabled: isDisabled,
    onSaveClick: onSaveClick,
    permanentlyDisabled: permanentlyDisabled,
    isUngatedForPatagonia: isUngatedForPatagonia
  });
};
BlogSaveButtonContainer.propTypes = {
  allowedSave: PropTypes.bool.isRequired,
  contentTypeNoun: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  permanentlyDisabled: PropTypes.bool.isRequired,
  isUngatedForPatagonia: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(BlogSaveButtonContainer);